import Card from 'components/Layout/Card';
import React, { useState } from 'react';
import UnpaidFollowUps from './UnpaidFollowUps';
import "./FollowUpUsers.scss"
const FollowUpUsers = () => {
  const [tabType, setTabType] = useState('0');
  const activeClass = 'p-2 bg-new-car color-white text-16-500 me-4';
  const inActiveClass = 'p-2 color-black-olive text-16-500 me-4 pointer';

  return (
    <>
      <div id="followup-users-container">
        <Card className="d-flex align-items-center p-2 unset-br mb-3">
          <div className="d-flex align-items-center flex-wrap gap-2">
            <div
              className={tabType === '0' ? activeClass : inActiveClass}
              onClick={() => {
                setTabType('0');
              }}
            >
              Unpaid
            </div>
            <div
              className={tabType === '1' ? activeClass : inActiveClass}
              onClick={() => {
                setTabType('1');
              }}
            >
              Paid
            </div>
          </div>
        </Card>
        {tabType === '0' && <UnpaidFollowUps />}
      </div>
    </>
  );
};

export default FollowUpUsers;
